import SuperTransfer from './superTransfer';
import type { SuperTransferProps } from './interface';

export type { SuperTransferProps };

export default SuperTransfer;
